export default __webpack_public_path__ + "static/media/book.7bc196fe.jpg";